import { gql } from "@apollo/client";

export const curbsuiteTransactionLogEntryFragment = gql`
  fragment curbsuiteTransactionLogEntryFragment on financial_transaction_log_no_balance {
    transactionId: transaction_id
    firstPark: first_park
    unregisteredVehicleViolation: unregistered_vehicle_violation
    policyViolation: policy_violation
    transactionType: transaction_type
    eventType: event_type
    potentialRevenue: potential_revenue
    price
    tripFeeAmount: trip_fee_amount
    rateBasis: rate_basis
    serviceFeeAmount: service_fee_amount
    revenue
    currency
    addressCity: address_city
    addressState: address_state
    addressStreet: address_street
    startTime: start_time
    endTime: end_time
    transactionDate: transaction_date
    transactionTs: transaction_ts
    createdAt: created_at
    assignedToAccountAtLocalDate: assigned_to_account_at_local_date
    # AUT-6163: adjustment (chargeback/credit) rows -- see AUT-6160 for the view columns.
    referenceTransactionId: reference_transaction_id
    referenceTransactionIndex: reference_transaction_index
    referenceTransactionType: reference_transaction_type
    referenceGatewayTransactionType: reference_gateway_transaction_type
    # The referenced charge's own log row (AUT-6160 relationship), for the dates the month picker
    # filters on: an adjustment's "Adjusts #" link opens the referenced charge's month.
    referencedTransaction: referenced_transaction {
      transactionDate: transaction_date
      assignedToAccountAtLocalDate: assigned_to_account_at_local_date
    }
    payerAccount: payer_account {
      organizationName: organization_name
    }
    transaction {
      index
      # An adjustment's free-text reason (AUT-6158); the log views don't carry it.
      description
      gatewayTransactions: gateway_transactions(limit: 1) {
        gatewayTransactionType: gateway_transaction_type
      }
      registeredVehicle: registered_vehicle {
        licensePlate: license_plate
        stateCode: state_code
      }
      sessionStartedAtLocal: session_started_at_local
      sessionEndedAtLocal: session_ended_at_local
    }
  }
`;
